module.exports = __webpack_public_path__ + "static/img/4.771a45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/4.png
// module id = L5xC
// module chunks = 4